import React from "react";
import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, CustomRollDataConversionCriteria } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  PageListBean,
  PurchaseOrderReceiptSearchCriteria,
  PurchaseOrderSearchCriteria,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPurchaseOrderListRequest,
  RestPurchaseOrderReceiptListRequest,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventoryBean,
  SKUBatchInventoryResultListResponseBean,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
class RollDataConversionMaintenance extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Roll Data Conversion Maintenance",
      criteria: new SKUBatchInventorySearchCriteria(),
      skuBatchData: new SKUBatchInventoryBean(),
      customRollDataConversionCriteria: new CustomRollDataConversionCriteria(),
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      inquiryDataList: [],
      selectedRowDataList: [],
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isDisableFields: false,
      isShowLookUp: true,
      isShowColorLookup: false,
      colorLookupHandler: null,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowCustomerModule: false,
      isShowFabricStyleModule: false,
      customerReservePageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerReserveList: true,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      showAutoCompletePurchaseOrderList: true,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
      showAutoCompletepurchaseReceiptList: true,
      warehouses: [],
      isInquiryDatasFound: false,
      isDisableInput: false,
      is3PL: false,
      // isViewMode: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });

    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order"
    );
    this.setState({ purchaseOrderLookupHandler: purchaseOrderLookupHandler });

    let purchaseOrderReceiptLookupHandler =
      new PurchaseOrderReceiptLookupHandler(
        this.companyCode,
        "Purchase Receipt"
      );
    this.setState({
      purchaseOrderReceiptLookupHandler: purchaseOrderReceiptLookupHandler,
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onRollDataChange = (e) => {
    let criteria = this.state.skuBatchData;
    criteria[e.target.name] = e.target.value;
    this.setState({ skuBatchData: criteria });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onCustomCriteriaChange = (e) => {
    let customRollDataConversionCriteria =
      this.state.customRollDataConversionCriteria;
    customRollDataConversionCriteria[e.target.name] = e.target.value;
    this.setState({
      customRollDataConversionCriteria: customRollDataConversionCriteria,
    });
  };
  clearCriteria = () => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    let skuBean = new SKUBatchInventoryBean();
    skuBean.companyCode = this.companyCode;
    skuBean.customerName = "";
    this.setState({
      criteria: criteria,
      skuBatchData: skuBean,
      isShowColorLookup: false,
      fabricPageListForAutoCompleteList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      customRollDataConversionCriteria: new CustomRollDataConversionCriteria(),
    });
    this.hideAlertCallBack();
  };
  resetView = () => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    let skuBean = new SKUBatchInventoryBean();
    skuBean.companyCode = this.companyCode;
    skuBean.customerName = "";
    this.setState({
      criteria: criteria,
      skuBatchData: skuBean,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowLookUp: true,
      isDisableInput: false,
      isShowExecuteButton: true,
      fabricPageListForAutoCompleteList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      customerReservePageListForAutoCompleteList: new Array(),
      purchaseReceiptPageListForAutoCompleteList: new Array(),
      purchaseOrderPageListForAutoCompleteList: new Array(),
      customRollDataConversionCriteria: new CustomRollDataConversionCriteria(),
      selectedRowDataList: [],
      //isViewMode: false,
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (!isEmptyString(criteria.fabricStyleCode)) {
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 100;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing ...",
      });
      this.loadRollDataList(listRequest);
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "FabricCode is Required";
      } else {
        errMsg = "ItemCode is Required";
      }
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadRollDataList = (listRequest) => {
    if (SecurityAccessManager.RollDataConversionMaintenance_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageList(
        listRequest,
        this.loadRollDataListResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadRollDataListResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let resultList = new Array();
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        resultList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
      }
      this.setState({
        inquiryDataList: resultList,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookUp: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.loadFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            isDisable: false,
            isShowLookUp: true,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  loadFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.loadFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  loadFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }
  loadFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.loadFabricStyleDetail(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.loadFabricColourBySearchString(e.target.value);
    }
  };
  loadFabricColourBySearchString(searchString) {
    let criteria = this.state.criteria;
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };

  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let criteria = this.state.criteria;
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let reserveCustomerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(reserveCustomerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.reserveCustomerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reserveCustomerCode" &&
      showAutoCompleteList === true &&
      reserveCustomerCode !== ""
    ) {
      this.loadCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  loadCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.loadCustomerDetailResponse,
      this.errorCallBack
    );
  };
  loadCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.loadCustomerCodeResponse,
      this.errorCallBack
    );
  }
  loadCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.loadCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };

  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  onPurchaseOrderChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.showAutoCompletePurchaseOrderList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.showAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.showAutoCompletePurchaseOrderList;
      let criteria = this.state.criteria;
      criteria.purchaseOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        purchaseOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.errorCallBack
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder ..",
    });
    PurchaseOrderService.initPurchaseOrderModule(
      readrestInput,
      this.readPurchaseOrderResponse,
      this.errorCallBack
    );
  };
  readPurchaseOrderResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.purchaseOrderResponse != null) {
      if (!isEmptyArray(response.data.purchaseOrderResponse.purchaseOrder)) {
        let poBean = response.data.purchaseOrderResponse.purchaseOrder;
        let criteria = this.state.criteria;
        criteria.purchaseOrderNumber = poBean.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  receiptOnChange = (e) => {
    let purchaseReceitpNumber = e.target.value;
    this.state.showAutoCompletepurchaseReceiptList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
    if (isEmpty(purchaseReceitpNumber)) {
      this.state.showAutoCompletepurchaseReceiptList = false;
      let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
      let criteria = this.state.criteria;
      criteria.purchaseReceitpNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompletepurchaseReceiptList: showAutoCompleteList,
        criteria: criteria,
        purchaseReceiptPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseReceitpNumber" &&
      showAutoCompleteList === true &&
      purchaseReceitpNumber !== ""
    ) {
      this.readpurchaseReceiptBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  purchaseReceiptEnterKeyEventHandler = (e) => {
    let purchaseReceitpNumber = e.target.value;
    let criteria = this.state.criteria;
    this.setState({
      criteria: criteria,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletepurchaseReceiptList = (
    showAutoCompletepurchaseReceiptList
  ) => {
    this.setState({
      showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
    });
  };
  readpurchaseReceiptBySearchString(searchString) {
    let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
    receiptCriteria.companyCode = this.companyCode;
    receiptCriteria.purchaseOrderReceiptNumberStartsWith = searchString;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = receiptCriteria;
    PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
      requestInput,
      this.loadByPurchaseOrderReceiptResponse,
      this.errorCallBack
    );
  }
  loadByPurchaseOrderReceiptResponse = (response) => {
    let receiptList =
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
    let simpleAutoCompleteList = new Array();
    if (receiptList.length > 0 && receiptList != null) {
      receiptList.map((receipt) => {
        let simpleItemBean = {
          code: receipt.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      purchaseReceiptPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isApplied",
          0,
          false,
          null,
          false,
          null
          //  "2em", "8%"
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber"
      )
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Item",
          "fabricStyleCode",
          0,
          true,
          this.viewFabricModule
        )
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode",
          0,
          true,
          this.viewFabricModule
        )
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "fabricStyleColorCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Width", "widthCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Sku", "skuNumber", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Container", "containerNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Po#", "purchaseOrderNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PoReceipt",
        "purchaseOrderReceiptNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("BinLocation", "aisleInfoText")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "VendorLot",
        "vendorBatchNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("VendorRoll", "rollNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("BillOfLading", "billOfLading")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Shade", "shade")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("EtaDate", "etaDate")
    );

    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer",
        "reserveCustomerCode",
        0,
        true,
        this.viewCustomerModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CustomerName",
        "reserveCustomerName"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "OnHandQty",
        "onHandQuantity",
        1
      )
    );
    return columnList;
  };
  customerOnChange = (e) => {
    let reserveCustomerCode = e.target.value;
    this.state.showAutoCompleteCustomerReserveList = true;
    let tempCriteria = this.state.skuBatchData;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerReserveList;
    if (isEmpty(reserveCustomerCode)) {
      this.state.showAutoCompleteCustomerReserveList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerReserveList;
      let criteria = this.state.skuBatchData;
      criteria.reserveCustomerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerReserveList: showAutoCompleteList,
        skuBatchData: criteria,
        customerReservePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reserveCustomerCode" &&
      showAutoCompleteList === true &&
      reserveCustomerCode !== ""
    ) {
      this.loadCustomerReserveSearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ skuBatchData: tempCriteria });
  };
  loadCustomerDetailReserveResponse = (response) => {
    let criteria = this.state.skuBatchData;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.reserveCustomerCode = customerData.code;
        this.setState({
          skuBatchData: criteria,
        });
      }
    }
  };
  loadCustomerReserveDetail = (reserveCustomerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = reserveCustomerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.loadCustomerDetailReserveResponse,
      this.errorCallBack
    );
  };
  loadCustomerReserveSearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.loadCustomerCodeReserveResponse,
      this.errorCallBack
    );
  }
  loadCustomerCodeReserveResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerReservePageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerEnterKeyEventHandler = (e) => {
    let reserveCustomerCode = e.target.value;
    this.loadCustomerReserveDetail(reserveCustomerCode);
    this.setState({
      customerReservePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerReserveList: showAutoCompleteList,
    });
  };
  selectAll = (e) => {
    if (e.detail === 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isApplied = true;
      });
      this.setState({ selectedRowDataList: list });
    }
  };
  unSelectAll = (e) => {
    if (e.detail === 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isApplied = false;
      });
      this.setState({ selectedRowDataList: [] });
    }
  };
  onSelectedChange = (val, rowData) => {
    if (rowData.isApplied === true) {
      let selectedLine = this.state.selectedRowDataList;
      selectedLine.push(rowData);
      this.setState({ selectedRowDataList: selectedLine });
    } else {
      let checkLines = this.state.selectedRowDataList;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isApplied != rowData.isApplied) {
          selectedLine.push(line);
          this.setState({ selectedRowDataList: selectedLine });
        } else if (this.state.selectedRowDataList.length == 1) {
          this.setState({ selectedRowDataList: [] });
        }
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewFabricModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  validateRollLine = (skuBatchData) => {
    let isValid = false;
    let customRollDataConversionCriteria =
      this.state.customRollDataConversionCriteria;
    let skuUpdateRowList = this.state.selectedRowDataList;
    let err_list = [];
    if (skuUpdateRowList.length == 0) {
      let errMsg = "select,sku batch lines";
      err_list.push(errMsg);
    }
    if (
      customRollDataConversionCriteria.IsContainerUpdateFlag == false &&
      customRollDataConversionCriteria.IsShadeUpdateFlag == false &&
      customRollDataConversionCriteria.IsBillofLadingUpdateFlag == false &&
      customRollDataConversionCriteria.IsVendorBatchNumberUpdateFlag == false &&
      customRollDataConversionCriteria.IsEtaDateUpdateFlag == false &&
      customRollDataConversionCriteria.IsReserveCustomerUpdateFlag == false
    ) {
      let errMsg = "Check The CheckBox for the Field to be Updated";
      err_list.push(errMsg);
    }
    if (
      customRollDataConversionCriteria.IsReserveCustomerUpdateFlag === true &&
      isEmptyString(skuBatchData.reserveCustomerCode)
    ) {
      let errMsg = "Customer Empty!";
      err_list.push(errMsg);
    }
    if (
      customRollDataConversionCriteria.IsShadeUpdateFlag === true &&
      isEmptyString(skuBatchData.shade)
    ) {
      let errMsg = "Shade Empty!";
      err_list.push(errMsg);
    }
    if (
      customRollDataConversionCriteria.IsBillofLadingUpdateFlag === true &&
      isEmptyString(skuBatchData.billOfLading)
    ) {
      let errMsg = "billOfLading Empty!";
      err_list.push(errMsg);
    }
    if (
      customRollDataConversionCriteria.IsVendorBatchNumberUpdateFlag === true &&
      isEmptyString(skuBatchData.vendorBatchNumber)
    ) {
      let errMsg = "vendorBatchNumber Empty!";
      err_list.push(errMsg);
    }
    if (
      customRollDataConversionCriteria.IsContainerUpdateFlag === true &&
      isEmptyString(skuBatchData.containerNumber)
    ) {
      let errMsg = "containerNumber Empty!";
      err_list.push(errMsg);
    }
    if (
      customRollDataConversionCriteria.IsEtaDateUpdateFlag === true &&
      isEmptyString(skuBatchData.etaDate)
    ) {
      let errMsg = "etaDate Empty!";
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  applyRollData = (e) => {
    if (e.detail === 1) {
      let skuBatchData = this.state.skuBatchData;
      let customRollDataConversionCriteria =
        this.state.customRollDataConversionCriteria;
      let skuUpdateRowList = this.state.selectedRowDataList;
      let currentSkuUpdateList = new Array();
      let isValidLine = false;
      isValidLine = this.validateRollLine(skuBatchData);
      if (isValidLine == true) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Sku Batch Update...",
        });
        skuUpdateRowList.map((roll) => {
          roll.companyCode = this.companyCode;
          if (customRollDataConversionCriteria.IsShadeUpdateFlag === true) {
            roll.shade = skuBatchData.shade;
          }
          if (
            customRollDataConversionCriteria.IsReserveCustomerUpdateFlag ===
            true
          ) {
            roll.reserveCustomerCode = skuBatchData.reserveCustomerCode;
          }
          if (
            customRollDataConversionCriteria.IsReserveCustomerUpdateFlag ===
            true
          ) {
            roll.reserveCustomerName = skuBatchData.customerName;
          }
          if (
            customRollDataConversionCriteria.IsBillofLadingUpdateFlag === true
          ) {
            roll.billOfLading = skuBatchData.billOfLading;
          }
          if (
            customRollDataConversionCriteria.IsVendorBatchNumberUpdateFlag ===
            true
          ) {
            roll.vendorBatchNumber = skuBatchData.vendorBatchNumber;
          }
          if (customRollDataConversionCriteria.IsContainerUpdateFlag === true) {
            roll.containerNumber = skuBatchData.containerNumber;
          }
          if (customRollDataConversionCriteria.IsEtaDateUpdateFlag === true) {
            roll.etaDate = skuBatchData.etaDate;
          }
          currentSkuUpdateList.push(roll);
        });
        this.updateSkuBatch(currentSkuUpdateList);
      }
    }
  };
  updateSkuBatch = (currentSkuUpdateList) => {
    let updateRequest = new SKUBatchInventoryResultListResponseBean();
    updateRequest.skuBatchInventories = currentSkuUpdateList;
    InventoryService.updateRollConventionSkuBatchInventory(
      updateRequest,
      this.updateSkuBatchResponse,
      this.errorCallBack
    );
  };
  updateSkuBatchResponse = (response) => {
    this.showErrorMessage(response.data);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data.success === true) {
      this.showInfoMessage(response.data);
      let upDatedRoll = new Array();
      upDatedRoll = response.data.skuBatchInventories;
      this.setState({
        inquiryDataList: upDatedRoll,
        selectedRowDataList: [],
        isShowExecuteButton: false,
      });
      this.disablesInput();
    }
  };
  disablesInput = () => {
    this.setState({
      isDisableInput: true,
    });
  };
  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          reset={this.resetView}
        />
        <RollDataEntrylist
          {...this.state}
          criteria={this.state.criteria}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          columnDefinitions={this.columnDefinitions}
          inquiryDataList={this.state.inquiryDataList}
          selectAll={this.selectAll}
          unSelectAll={this.unSelectAll}
          onRollDataChange={this.onRollDataChange}
          skuBatchData={this.state.skuBatchData}
          updatingSkuBatch={this.updatingSkuBatch}
          customerOnChange={this.customerOnChange}
          customerEnterKeyEventHandler={this.customerEnterKeyEventHandler}
          displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
          locationCodeOnChange={this.locationCodeOnChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          onPurchaseOrderChange={this.onPurchaseOrderChange}
          purchaseOrderEnterKeyEventHandler={
            this.purchaseOrderEnterKeyEventHandler
          }
          displayAutoCompletePurchaseOrderList={
            this.displayAutoCompletePurchaseOrderList
          }
          receiptOnChange={this.receiptOnChange}
          purchaseReceiptEnterKeyEventHandler={
            this.purchaseReceiptEnterKeyEventHandler
          }
          displayAutoCompletepurchaseReceiptList={
            this.displayAutoCompletepurchaseReceiptList
          }
          onCustomCriteriaChange={this.onCustomCriteriaChange}
          applyRollData={this.applyRollData}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerModule}
          popupLvlClass={"popupSizeLeve11"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class RollDataEntrylist extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {};
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onRollDataChange = (e) => {
    this.props.onRollDataChange(e);
  };
  render() {
    let criteria = this.props.criteria;
    let skuBatchData = this.props.skuBatchData;
    let customRollDataConversionCriteria =
      this.props.customRollDataConversionCriteria;
    return (
      <div>
        <Row className="d-flex justify-context-left">
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricSTyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              placeholder={this.props.is3PL ? "Item" : "FabricStyle"}
              onChange={this.props.fabricCodeOnChange}
              value={criteria.fabricStyleCode}
              showCriteriaDialog={true}
              lookupRequired={this.props.isShowLookUp}
              lookupHandler={this.props.fabricLookupHandler}
              enterKeyEventHandler={this.props.fabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.props.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              disabled={true}
              name="fabricStyleName"
              value={criteria.fabricStyleName}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.onFabricColourCodeChange}
              name="colorCode"
              placeholder="color"
              value={criteria.colorCode}
              lookupRequired={this.props.isShowColorLookup}
              lookupHandler={this.props.colorLookupHandler}
              enterKeyEventHandler={this.props.fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteFabricColorList
              }
              showAutoCompleteList={this.props.showAutoCompleteFabricColorList}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Location</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.locationCodeOnChange}
              name="locationCode"
              placeholder="location"
              value={criteria.locationCode}
              lookupRequired={true}
              lookupHandler={this.props.warehouseLookupHandler}
              enterKeyEventHandler={this.props.locationEnterKeyEventHandler}
              autoCompleteListData={
                this.props.locationPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteLocationList
              }
              showAutoCompleteList={this.props.showAutoCompleteLocationList}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="reserveCustomerCode"
              placeholder="Customer"
              onChange={this.props.customerCodeOnChange}
              value={criteria.reserveCustomerCode}
              lookupRequired={this.props.isShowLookUp}
              showCriteriaDialog={true}
              lookupHandler={this.props.customerLookupHandler}
              enterKeyEventHandler={this.props.customerCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.props.displayAutoCompleteList}
              showAutoCompleteList={this.props.showAutoCompleteCustomerList}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              disabled={true}
              name="customerName"
              placeholder="Customer Name"
              onChange={this.onChange}
              value={criteria.customerName}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Lot Number</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="vendorBatchNumber"
              value={criteria.vendorBatchNumber}
              onChange={this.onChange}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Bin Location</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="binLocation"
              value={criteria.binLocation}
              onChange={this.onChange}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Purchase Order</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.onPurchaseOrderChange}
              name="purchaseOrderNumber"
              placeholder="purchaseOrderNumber"
              value={criteria.purchaseOrderNumber}
              lookupRequired={this.props.isShowLookUp}
              lookupHandler={this.props.purchaseOrderLookupHandler}
              enterKeyEventHandler={
                this.props.purchaseOrderEnterKeyEventHandler
              }
              autoCompleteListData={
                this.props.purchaseOrderPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompletePurchaseOrderList
              }
              showAutoCompleteList={
                this.props.showAutoCompletePurchaseOrderList
              }
              disabled={this.props.isDisableFields}
              isMandatory={true}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>Purchase Order Receipt</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.receiptOnChange}
              name="purchaseReceitpNumber"
              placeholder="purchaseReceitpNumber"
              value={criteria.purchaseReceitpNumber}
              lookupRequired={true}
              lookupHandler={this.props.purchaseOrderReceiptLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={
                this.props.purchaseReceiptEnterKeyEventHandler
              }
              autoCompleteListData={
                this.props.purchaseReceiptPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompletepurchaseReceiptList
              }
              showAutoCompleteList={
                this.props.showAutoCompletepurchaseReceiptList
              }
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Container</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="containerNumber"
              value={criteria.containerNumber}
              onChange={this.onChange}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>
              {this.props.is3PL ? "Inventory#From" : "RollSKU#From"}
            </FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fromRollSkuNumber"
              value={criteria.fromRollSkuNumber}
              onChange={this.onChange}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>
              {this.props.is3PL ? "Inventory#To" : "RollSKU#To"}
            </FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="toRollSkuNumber"
              value={criteria.toRollSkuNumber}
              onChange={this.onChange}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>InTransitOnly</FormLabel>
          </Col>
          <Col sm="2">
            <InputCheckbox
              type="checkbox"
              name="isTransitOnly"
              onChange={this.onChange}
              checked={criteria.isTransitOnly}
              disabled={this.props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>

        <Row>
          {this.props.isInquiryDatasFound && (
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                size="sm"
                onClick={(e) => this.props.selectAll(e)}
              >
                SelectAll
              </Button>
            </Col>
          )}
          {this.props.isInquiryDatasFound && (
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                size="sm"
                onClick={(e) => this.props.unSelectAll(e)}
              >
                UnselectAll
              </Button>
            </Col>
          )}
        </Row>
        <div className="header_div">
          <Row>
            <Col sm="2">
              <FormLabel  className="label_head">Sku Batch Lines</FormLabel>
            </Col>
          </Row>
          <div className="div_Custom_3">
            <EditableDataGrid
              columnsList={this.props.columnDefinitions()}
              dataList={this.props.inquiryDataList}
            />
          </div>
        </div>
        <Row>
          <Col sm="2">
            <FormLabel  className="label_head">Input Lines</FormLabel>
          </Col>
        </Row>

        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="reserveCustomerCode"
              placeholder="Customer"
              onChange={this.props.customerOnChange}
              value={skuBatchData.reserveCustomerCode}
              lookupRequired={true}
              showCriteriaDialog={true}
              lookupHandler={this.props.customerLookupHandler}
              enterKeyEventHandler={this.props.customerEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerReservePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteCustomerList
              }
              showAutoCompleteList={
                this.props.showAutoCompleteCustomerReserveList
              }
              disabled={this.props.isDisableInput}
              isMandatory={true}
            />
          </Col>
          <div class="form-check form-check-inline">
            <Col>
              <InputCheckbox
                class="form-check-input"
                type="checkbox"
                name="IsReserveCustomerUpdateFlag"
                onChange={this.props.onCustomCriteriaChange}
                checked={
                  customRollDataConversionCriteria.IsReserveCustomerUpdateFlag
                }
                disabled={this.props.isDisableInput}
              />
            </Col>
          </div>
          <Col sm="1">
            <FormLabel>BillOfLading</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="billOfLading"
              value={skuBatchData.billOfLading}
              onChange={this.onRollDataChange}
              disabled={this.props.isDisableInput}
              isMandatory={true}
            />
          </Col>
          <div class="form-check form-check-inline">
            <Col>
              <InputCheckbox
                class="form-check-input"
                type="checkbox"
                name="IsBillofLadingUpdateFlag"
                onChange={this.props.onCustomCriteriaChange}
                checked={
                  customRollDataConversionCriteria.IsBillofLadingUpdateFlag
                }
                disabled={this.props.isDisableInput}
              />
            </Col>
          </div>
          <Col sm="1">
            <FormLabel>ETA Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="etaDate"
              value={skuBatchData.etaDate}
              onChange={this.onRollDataChange}
              disabled={this.props.isDisableInput}
              isMandatory={true}
            />
          </Col>
          <div class="form-check form-check-inline">
            <Col>
              <InputCheckbox
                class="form-check-input"
                type="checkbox"
                name="IsEtaDateUpdateFlag"
                onChange={this.props.onCustomCriteriaChange}
                checked={customRollDataConversionCriteria.IsEtaDateUpdateFlag}
                disabled={this.props.isDisableInput}
              />
            </Col>
          </div>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Shade</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="shade"
              value={skuBatchData.shade}
              onChange={this.onRollDataChange}
              disabled={this.props.isDisableInput}
              isMandatory={true}
            />
          </Col>
          <div class="form-check form-check-inline">
            <Col>
              <InputCheckbox
                class="form-check-input"
                type="checkbox"
                name="IsShadeUpdateFlag"
                onChange={this.props.onCustomCriteriaChange}
                checked={customRollDataConversionCriteria.IsShadeUpdateFlag}
                disabled={this.props.isDisableInput}
              />
            </Col>
          </div>
          <Col sm="1">
            <FormLabel>Lot</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="vendorBatchNumber"
              value={skuBatchData.vendorBatchNumber}
              onChange={this.onRollDataChange}
              disabled={this.props.isDisableInput}
              isMandatory={true}
            />
          </Col>
          <div class="form-check form-check-inline">
            <Col>
              <InputCheckbox
                class="form-check-input"
                type="checkbox"
                name="IsVendorBatchNumberUpdateFlag"
                onChange={this.props.onCustomCriteriaChange}
                checked={
                  customRollDataConversionCriteria.IsVendorBatchNumberUpdateFlag
                }
                disabled={this.props.isDisableInput}
              />
            </Col>
          </div>
          <Col sm="1">
            <FormLabel>Container</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="containerNumber"
              value={skuBatchData.containerNumber}
              onChange={this.onRollDataChange}
              disabled={this.props.isDisableInput}
              isMandatory={true}
            />
          </Col>
          <div class="form-check form-check-inline">
            <Col>
              <InputCheckbox
                class="form-check-input"
                type="checkbox"
                name="IsContainerUpdateFlag"
                onChange={this.props.onCustomCriteriaChange}
                checked={customRollDataConversionCriteria.IsContainerUpdateFlag}
                disabled={this.props.isDisableInput}
              />
            </Col>
          </div>
        </Row>
        <Row>
          <Col sm="12">
            <Button
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.props.applyRollData(e)}
            >
              Apply
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
function RollDataConversionModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <RollDataConversionMaintenance {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default RollDataConversionModule;
